import { createRouter, createWebHistory } from 'vue-router'
import HomePage from './pages/HomePage.vue'
import ReaderPage from './pages/ReaderPage.vue'
import PrivacyPage from './pages/PrivacyPage.vue'
import AppOpenPage from './pages/AppOpenPage.vue'

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', name: 'home', component: HomePage },
    { path: '/privacy', name: 'privacy', component: PrivacyPage },
    { path: '/open/:landingId', name: 'app-open', component: AppOpenPage },
    { path: '/r/:landingId', name: 'landing', component: ReaderPage },
    { path: '/s/:storySlug', name: 'preview', component: ReaderPage },
    { path: '/:pathMatch(.*)*', name: 'not-found', component: ReaderPage },
  ],
  scrollBehavior() {
    return { top: 0 }
  },
})
